(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
document.querySelector('.play-button').addEventListener("click", function (e) {
  this.style.zIndex = 0;
  document.querySelector('.feature-container p:has(img)').style.zIndex = 0;

  let element = document.querySelector('.feature-container iframe');
  let src = document.querySelector('.feature-container iframe').src;
  src = src.replace("autoplay=0", "autoplay=1");
  element.src = src;
});

  } catch(e) { console.error(e); }
})();
})();
